<template>
  <div class="GymPopup">
    <div class="mask-container" @click.stop="onClose"></div>
    <div class="pop-cent">
      <div class="cent-title">
        <div class="cent-t-name">
          {{ arr[cur].title }}
          <!-- 拍 -->
          <img
            v-if="cur == 1"
            class="icon-img"
            src="https://cdnvue.gymcity.com.cn/uploads/pub-25jlpp-icon"
            alt=""
          />
          <!-- 孕 -->
          <img
            v-if="cur == 2"
            class="icon-img-yun"
            src="https://cdnvue.gymcity.com.cn/uploads/pub-cocah-tag-yun"
            alt=""
          />
        </div>
        <i class="iconfont iconguanbi" @click.stop="onClose"></i>
      </div>

      <div class="cent-text">{{ arr[cur].cent }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GymPopup',
  props: {
    cur: {}, // 标题
    isSlot: {} // 是否有slot
  },
  data() {
    return {
      arr: {
        1: {
          title: '拍照认证',
          icon: '拍',
          cent: '预约拥有拍拍认证的教练，解锁专属健身大片拍摄，获得朋友圈、小红书高赞素材，练得好更要晒得漂亮，让每一次晒照都攒足下次训练的期待！'
        },
        2: {
          title: '孕产认证',
          icon: '孕',
          cent: '该教练已通过芬兰Koskitech等国际机构的严格考核，取得了国内孕产私教必备的进阶认证，能够通过国际最前沿的产后运动信息及技术为会员进行产后修复、塑型训练。教练从业超过2年且服务超过50名以上的产后妈妈。'
        }
      }
    }
  },
  created() {},
  methods: {
    onClose() {
      this.$emit('boxClose')
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 375) * 100vw;
}
.GymPopup {
  .mask-container {
    background-color: #000;
    position: fixed;
    top: 0;
    left: 0;
    opacity: 0.6;
    width: 100%;
    height: 100%;
    z-index: 99;
  }
  .pop-cent {
    width: vw(343);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    box-sizing: border-box;
    padding: vw(16) vw(23);
    background-color: #fff;
    border-radius: vw(8);
    color: #000;
    text-align: left;
    z-index: 100;
    .cent-title {
      width: 100%;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .cent-t-name {
        font-size: 4.8vw;
        font-weight: 600;
        display: flex;
        align-items: center;
        .icon-img-yun {
          width: auto;
          height: 4.8vw;
          margin-left: 1.2vw;
        }
        .icon-img {
          width: 4.8vw;
          height: auto;
          margin-left: 1.2vw;
          border-radius: 1.2vw;
        }
      }
      .iconguanbi {
        font-size: 3.2vw;
        color: #ccc;
      }
    }
    .cent-text {
      width: 100%;
      box-sizing: border-box;
      margin-top: 2.7vw;
      font-size: 3.5vw;
    }
  }
}
</style>
<style lang="scss">
.GymMessageBox {
  .animated {
    animation-duration: 0.5s;
  }
}
</style>
